import styled from 'styled-components';

export const FormGroup = styled.div`
  margin-bottom: 1.5rem;
  .p-inputtext {
    width: 100%;
  }

  small.p-error {
    color: red;
    font-size: 0.75rem;
  }
`;

export const FormContainer = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 2rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

export const FormTitle = styled.h2`
  text-align: center;
  margin-bottom: 2rem;
  font-size: 1.8rem;
`;

/* Shared form layout components used across all subcomponents */

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  width: 100%;
  @media (max-width: 768px) { grid-template-columns: 1fr; }
`;

export const AccordionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const AddButtonRow = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
`;

export const ActionRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;

export const FormWrapper = styled.div`
  padding: 20px 0;
`;
